__turbopack_context__.v({
  "className": "dinroundprofont_3999247f-module__d82JVq__className",
  "variable": "dinroundprofont_3999247f-module__d82JVq__variable",
});
